import { Injectable } from '@angular/core';
import { sortBy } from 'lodash';

@Injectable()
export class LandingPricingService {

  constructor() { }

  list =
    {
      ch: [
        {
          size: '10x10',
          unit: 'cm',
          basePrice: '9.95',
          additionalPagePrice: '0.50',
          currency: 'CHF',
          pageNumber: '26',
        },
        {
          size: '13x13',
          unit: 'cm',
          basePrice: '14.95',
          additionalPagePrice: '0.70',
          currency: 'CHF',
          pageNumber: '26',
        },
        {
          size: '20x20',
          unit: 'cm',
          basePrice: '29.95',
          additionalPagePrice: '0.95',
          currency: 'CHF',
          pageNumber: '26',
        },
        {
          size: '30x30',
          unit: 'cm',
          basePrice: '49.95',
          additionalPagePrice: '1.45',
          currency: 'CHF',
          pageNumber: '26',
        }
      ],
      us: [
        {
          size: '5x5',
          unit: 'inches',
          basePrice: '9.95',
          additionalPagePrice: '0.39',
          currency: '$',
          pageNumber: '16',
        },
        {
          size: '8x8',
          unit: 'inches',
          basePrice: '24.95',
          additionalPagePrice: '0.59',
          currency: '$',
          pageNumber: '16',
        },
        {
          size: '10x10',
          unit: 'inches',
          basePrice: '34.95',
          additionalPagePrice: '0.79',
          currency: '$',
          pageNumber: '16',
        },
        {
          size: '12x12',
          unit: 'inches',
          basePrice: '49.95',
          additionalPagePrice: '0.99',
          currency: '$',
          pageNumber: '16',
        }
      ]
    }
  ;

  getCh() {
    return this.list.ch;
  }

  getUs() {
    return this.list.us;
  }
}
